<div class="center" gs1Spinner [big]="true" [size]="'80px'" [mainLoader]="true"></div>
